import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BillingService } from '../BillingService';

// Purchase Order mutations
export const useVerifyPurchaseOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => BillingService.verifyPurchaseOrder(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['billing'] });
      queryClient.invalidateQueries({ queryKey: ['billing', 'info', id] });
    },
  });
};

// Milestone mutations
export const useVerifyMilestone = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => BillingService.verifyMilestone(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['milestones'] });
    },
  });
};

// Invoice mutations
export const useVerifyInvoice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => BillingService.verifyInvoice(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
      queryClient.invalidateQueries({ queryKey: ['invoices', 'info', id] });
    },
  });
};

export const useConfirmInvoicePayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) =>
      BillingService.confirmInvoicePayment(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
      queryClient.invalidateQueries({ queryKey: ['invoices', 'info', id] });
    },
  });
};

// Credit Note mutations
export const useApproveCreditNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => BillingService.approveCreditNote(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['credit-notes'] });
      queryClient.invalidateQueries({ queryKey: ['credit-notes', 'info', id] });
    },
  });
};
